(function() {
    'use strict';
    angular.module('wbUtilities').factory('RiskScore', ['$q', 'DataService', 'NgTableParams', 'Request', function ($q, DataService, NgTableParams, Request) {
        var risk = {},
            riskData = {
                portfolios: null,
                retrievePromise: null,
            };

        /**
         * Get specific riskData key
         * @param type
         * @returns {*}
         */
        risk.get = function (type) {
            if (!type) {
                return riskData;
            } else {
                return riskData[type];
            }
        };


        risk.retrievePortfolios = function(refresh) {
            if (risk.getPortfolios() && !refresh) {
                return $q.when(risk.getPortfolios());
            } else {
                if (riskData.retrievePromise && !refresh) {
                    //in case retrieve is called before first call is completed
                    return riskData.retrievePromise;
                } else {
                    riskData.retrievePromise = Request.make("risk_score_models").then(function (response) {
                        riskData.portfolios = response.data.response.portfolios;

                        angular.forEach(riskData.portfolios, function (portfolio) {
                            portfolio.stock_percent = portfolio.target_stock_rate * 100;
                            portfolio.bond_percent = portfolio.target_bond_rate * 100;
                            angular.forEach(portfolio.asset_classes, function (asset) {
                                asset.percent = asset.target_allocation_rate * 100;
                            });
                        });

                        return riskData.portfolios;
                    });
                    return riskData.retrievePromise;
                }
            }
        };
        risk.getPortfolios = function() {
            return risk.get('portfolios');
        };

        risk.getCorePortfolio = function() {
            return {
                slug: "core",
                imageAsset: "CORE",
                name: "Managed Portfolios Core",
                description: "Our original portfolio of stock and bond ETFs."
            }
        };

        risk.getAllocationChartData = function() {

        };
        risk.getSimpleAllocation = function(allocation, cash) {
            var portfolios = risk.getPortfolios();
            var stocks, bonds, simpleAllocation, cashRate;

            if (!cash) cash = 0;
            cashRate = cash / 100;

            if (portfolios && allocation in portfolios) {
                simpleAllocation = angular.copy(portfolios[allocation]);
                simpleAllocation.total_value = 0;

                simpleAllocation.stock_percent *= (1-cashRate);
                simpleAllocation.bond_percent *= (1-cashRate);

                simpleAllocation.positions = [
                    {
                        name: "Stock",
                        category: "Stock",
                        percent: simpleAllocation.stock_percent,
                        code: "stock",
                    },
                    {
                        name: "Bond",
                        category: "Bond",
                        percent: simpleAllocation.bond_percent,
                        code: "bond"
                    },
                    {
                        name: "Ca$h Money",
                        category: "Cash",
                        percent: cash,
                        code: "USD"
                    }
                ];

                return simpleAllocation;
            }

        };


        risk.formatPortfolio = function(portfolio, cash = 0, withAssets = false) {

            var assetClassesFiltered = [], hasCashAsset = false;
            angular.forEach(portfolio.asset_classes, function (asset, index) {
                if (!asset.target_allocation_rate) return;

                asset.percent = asset.target_allocation_rate * 100 * (1-cash);
                if (!asset.assets && withAssets) {
                    //for core portfolios
                    var ac = DataService.getAssetClass(asset.code);
                    if (ac) {
                        asset.assets = ac.assets;
                    }
                }
                if (asset.code === 'USD') {
                    hasCashAsset = true;
                }
                assetClassesFiltered.push(asset);
            });
            portfolio.asset_classes = assetClassesFiltered;

            if (!hasCashAsset) {
                portfolio.asset_classes.push({
                    "code": "USD",
                    "name": "USD",
                    "percent": cash * 100,
                    "category": "Cash",
                    "tickers": [{
                        "ticker": "USD",
                        "ticker_name": "Cash",
                        "percent": 0,
                    }]
                });
            }

            portfolio.bonds = { percent: portfolio.target_bond_rate * 100 * (1-cash)};
            portfolio.stocks = { percent: portfolio.target_stock_rate * 100 * (1-cash)};
            portfolio.cash = { percent: cash * 100 };

            return portfolio;
            //
            // DataService.retrieveAssetClasses().then(function() {
            //
            // });
        };

        risk.getAssetTableParams = function(portfolio) {
            return new NgTableParams({
                //params
                count: 1000,
                group: function(item) {
                    //returns name of group which is also sorted alphabetically
                    return item.category.toLowerCase();
                },
                filter: {
                    //an object filter that would be used as an object expression
                    //in the settings.filterOptions.filterFn method
                },
                sorting: {}, // data_key: "asc|desc"
            }, {
                //settings
                counts: [],
                dataset: portfolio ? portfolio.asset_classes : [],
                groupDataset: portfolio, //made up to store data used in response interceptor
                groupOptions: {
                    defaultSort: false
                },
                interceptors: [
                    {
                        response: function(data, params) {
                            //data should be grouped, want to sort in proper order
                            var sortingArr = ['stocks', 'bonds', 'cash'];
                            data.sort((a, b) => (sortingArr.indexOf(a.value) - sortingArr.indexOf(b.value)));
                            var groupDataset = params.settings().groupDataset || {};
                            data.forEach(function(d) {
                                if (d.value in groupDataset) {
                                    d.groupData = groupDataset[d.value];
                                }
                            });
                            return data;
                        }
                    }
                ]
            });
        };

        return risk;
    }]);
})();
